import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { Strategy } from "@front/m19-api-client";
import { SdStrategyCreationComponent } from "@m19-board/sponsored-display/sd-manager/sd-strategy-creation/sd-strategy-creation.component";

@Component({
  template: ` <app-sd-strategy-creation (strategyCreated)="onStrategyCreated($event)" /> `,
  imports: [SdStrategyCreationComponent],
  host: {
    class: "block h-full min-h-0",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdStrategyCreationPageComponent {
  private readonly router = inject(Router);

  onStrategyCreated(strategy: Strategy) {
    void this.router.navigate(["/advertising/sponsored-display/" + strategy.strategyId], {
      queryParamsHandling: "merge",
    });
  }
}
